import "./App.css";
import { Route, Routes, Navigate } from "react-router";
import { App, ColorPicker, ConfigProvider, Radio, Space } from "antd";
import { HashRouter } from "react-router-dom";
import {
  LOGIN,
  LANDING,
  AR_NO_MATCH,
  UNAUTHORIZED_PATH,
  ELECTRICAL_DASHBOARD,
  SIGNUP,
} from "./Common/Constants";
import LandingPage from "./components/CommonScreens/LandingPage";
import LiveChart from "./components/Screens/Electrical/Charts/LiveModule/LiveTrends/LineChart/LiveChart";
import MeterStatus from "./components/Screens/Electrical/Charts/LiveModule/MeterStatus/MeterStatus";
import {ElectricalItems,ElectricalNavItems} from "./components/Elements/NavRoutes";
import SidebarLayout from "./components/CommonScreens/SidebarLayout";

import ParameterView from "./components/Screens/Electrical/Charts/LiveModule/ParameterView/ParameterView";
import PrivateRoutes from "./Store/PrivateRoute";
import ComparitiveReport from "./components/Screens/Electrical/Charts/HistoricalReports/ComparativeReport/ComparativeRepot";
import ConsumptionReportElectrical from "./components/Screens/Electrical/Charts/HistoricalReports/ConsumptionReport/ConsumptionReportElectrical";
import RawDataElectrical from "./components/Screens/Electrical/Charts/HistoricalReports/RawData/RawDataGrid/RawData";

import { useDispatch, useSelector } from "react-redux";
import ElectricalHistoricalTrends from "./components/Screens/Electrical/Charts/HistoricalReports/HistoricalTrends/ElectrialHistoricalTrends";
import GroupConfig from "./components/Screens/Electrical/Charts/Groups/Group-Config/GroupConfig";
import ElectricalGroup from "./components/Screens/Electrical/Charts/Groups/Group/ElectricalGroups.jsx";
import ElectricalSubGroup from "./components/Screens/Electrical/Charts/Groups/Subgroup/ElectricalSubGroup.jsx";
import GroupReport from "./components/Screens/Electrical/Charts/Groups/GroupReport/GroupReport.jsx";
import CustomThemeDrawer from "./components/Elements/CustomThemeDrawer.jsx";
import {
  SunOutlined,MoonOutlined
 } from "@ant-design/icons"; 
import { setCustomTheme, setTheme } from "./Store/Reducers/ThemeAction.jsx";
import { handledarkMode } from "./components/Elements/DarkModeAction.jsx";
import { useState } from "react";
import Alerts from "./components/Screens/Electrical/Charts/LiveModule/Alerts/Alerts.jsx";
import ManualData from "./components/Screens/Electrical/Charts/LiveModule/Manual Entry/ManualData.jsx";
import ManuallyEnteredData from "./components/Screens/Electrical/Charts/LiveModule/Manual Entry/ManuallyEnteredData.jsx";
import StatusView from "./components/Screens/Electrical/Charts/LiveModule/Manual Entry/StatusView.jsx";
import DashConverters from "./components/Screens/Configuration/Electrical/GroupConfiguration/DashConverters/DashConverters.jsx";
import GroupConfiguration from "./components/Screens/Configuration/Electrical/GroupConfiguration/GroupConfigurationScreen/GroupConfiguration.jsx";
import DashLive from "./components/Screens/Configuration/Electrical/GroupConfiguration/DashLive/DashLive.jsx";
import DashEnergy from "./components/Screens/Configuration/Electrical/GroupConfiguration/DashEnergy/DashEnergy.jsx";
import Dashboard from "./components/dashboard/Dashbard.jsx";
import PlotInterval from "./components/Screens/Electrical/Charts/LiveModule/PlotInterval/PlotInterval.jsx";
import SignUpForm from "./components/CommonScreens/SignUpForm.jsx";
import UserRoles from "./components/Screens/Configuration/Electrical/GroupConfiguration/Roles/UserRoles.jsx";
import UserRegister from "./components/Screens/Configuration/Electrical/GroupConfiguration/UserRegistration/UserRegistration.jsx";
import ScreenConfiguration from "./components/Screens/Configuration/Electrical/GroupConfiguration/Roles/ScreenConfiguration/ScreenConfiguration.jsx";
import LoginForm2 from "./components/CommonScreens/LoginForm2.jsx";
import NotAuthenticated from "./components/CommonScreens/NotAuthenicated.jsx";
import Settings from "./components/Screens/Electrical/Charts/LiveModule/Settings.jsx";
import SLD from "./components/Screens/Electrical/Charts/LiveModule/SLD/SLD.jsx";
import SLDConfiguration from "./components/Screens/Electrical/Charts/LiveModule/SLD/SLDConfiguration.jsx";
import ShiftReportElectrical from "./components/Screens/Electrical/Charts/ShiftReport/ShiftReport.jsx";
import ClientLicenseForm from "./components/CommonScreens/ClientLicenseForm.jsx";
import LicenseDetails from "./components/CommonScreens/LicenseDetails.jsx";
import PowerInterruptionReport from "./components/Screens/Electrical/Charts/HistoricalReports/ConsumptionReport/PowerInterruptionReport.jsx";
import MeterAlertConfigration from "./components/Screens/Electrical/Charts/LiveModule/Alerts/MeterAlertConfigration.jsx";
export default function Router() {

  const loggedIn = useSelector((state)=>state.user.login)
  // console.log(loggedIn)
  const [openTheme, setOpenTheme] = useState(false); 
  const mode = useSelector((state) => state.darkMode);
    const color = useSelector((state) => state.ThemeChange);
    
    // console.log(color)
    const [color1, setColor1] = useState("#3498db");
    const { isdarkMode } = mode; 

    const dispatch =useDispatch()
    const [selectedTheme, setSelectedTheme] = useState("green");

    const handleChange = (e) => {
      dispatch(setTheme(e.target.value))
      setSelectedTheme(e.target.value);
    };
      const switchDarkMode = () => {
        isdarkMode ? dispatch(handledarkMode(false)) : dispatch(handledarkMode(true));
      };
      const showThemeDrawer = () => {
        setOpenTheme(true);
      };
    
      const onThemeClose = () => {
        setOpenTheme(false);
      };

    
      const handleColorChange = (colorResult) => {
        const hex = colorResult.toHexString(); 
        setColor1(hex);
        dispatch(setCustomTheme(hex))
        setSelectedTheme('Custom');
     
      };

  return ( 
<ConfigProvider
  theme={{
    token: {
      colorPrimary: color.themeConfig.colorPrimary,
      colorPrimaryHover: color.themeConfig.colorPrimaryHover,
    },
    components: {
      Button: {
        colorPrimary: color.themeConfig.colorPrimary,
        colorPrimaryHover: color.themeConfig.colorPrimaryHover,
        colorPrimaryActive: color.themeConfig.colorPrimaryHover,
      },
      Input: {
        activeBorderColor: color.themeConfig.colorPrimary,
        hoverBorderColor: color.themeConfig.colorPrimary,
      },
      Modal: {
        colorPrimary: color.themeConfig.colorPrimary,
      },
      DatePicker: {
        colorPrimary: color.themeConfig.colorPrimary,
        colorPrimaryHover: color.themeConfig.colorPrimaryHover,
      },
      RangePicker: {
        colorPrimary: color.themeConfig.colorPrimary,
        colorPrimaryHover: color.themeConfig.colorPrimaryHover,
      },
      Table: {
        headerBg: color.themeConfig.colorPrimary,  // Header background color
        headerColor: "#fff",  // Header text color
        rowHoverBg: color.themeConfig.colorPrimaryHover, // Row hover effect
        colorBorderSecondary: color.themeConfig.colorPrimary, // Border color
        colorBgContainer: isdarkMode === "dark" ? "#292c35" : "#fff", // Background color for dark mode
      },
    },
  }}
>


      <App className="overflow-hidden">
        <HashRouter>
          <Routes >
 
                {/* <Route path={LOGIN} element={<LoginForm/>}/> */}
                <Route path={LOGIN} element={<LoginForm2/>}/>
                <Route path={'/license-form'} element={<ClientLicenseForm/>}/>
                {/* <Route path={LANDING+ "/"} element={<LandingPage/>}/> */}
                <Route path={SIGNUP} element={<SignUpForm/>}/>
                <Route path={UNAUTHORIZED_PATH} element={<NotAuthenticated/>}/>
   <Route
      path={LANDING}
      element={
        <PrivateRoutes>
          <LandingPage />
        </PrivateRoutes>
      }
    />           

                {/* Electrical layout */}
                <Route
                path={ELECTRICAL_DASHBOARD + "/*"}
                  element={
                    <PrivateRoutes>
                      {/* <AutoLogout timeout={60 * 60 * 1000}> */}
                      <SidebarLayout
                        NavItems={ElectricalNavItems}
                        items={ElectricalItems}
                        title={'Electrical'}
                        DefaultRoute={<Dashboard />}
                      />
                      {/* </AutoLogout> */}
                    </PrivateRoutes>
                  }
                >
                  {/* <Route path="tree-chart" element={<OrgChartData />}>
                    <Route path="tree-chart-popup" element={<OrgChartData />} />
                  </Route> */}

                  
 
                  <Route path="sld" element={<SLD/>} />
                  <Route path="license-details" element={<LicenseDetails/>} />
                  <Route path="sld-config" element={<SLDConfiguration/>} />
                  <Route path="alerts" element={<Alerts/>} />
                  <Route path="meter-alert-configration" element={<MeterAlertConfigration/>} />
                  
                  <Route path="settings" element={<Settings/>} />
                  <Route path="License-information" element={<LicenseDetails/>} />
                  <Route path="status-view" element={<StatusView/>} /> 
                  <Route path="manual" element={<ManualData/>} />
                  <Route path="manual-entry-data" element={<ManuallyEnteredData/>} />
                  <Route path="dashboard" element={<Dashboard/>} />
                  <Route path="plot-interval" element={<PlotInterval/>} />
                  <Route path="live-trends" element={<LiveChart/>} />
                  <Route path="meter-status" element={<MeterStatus />}>
                    <Route path="meter-status-popup" element={<MeterStatus/>}/>
                  </Route>
                  <Route path="parameter-view" element={<ParameterView />} /> 
                  <Route path="comparative-report" element={<ComparitiveReport/>}/>
                  <Route path="raw-data" element={< RawDataElectrical />}/>
                  <Route path="historical-trends" element={<ElectricalHistoricalTrends /> } /> 
                  <Route path="consumption-report" element={<ConsumptionReportElectrical/>} />
                  <Route path="shift-report" element={<ShiftReportElectrical/>} />
                  <Route path="power-interruption-report" element={<PowerInterruptionReport/>} />

                  <Route path="groups" element={<ElectricalGroup/>}/>
                  <Route path="sub-group" element={<ElectricalSubGroup />}/>
                  <Route path="group-config" element={<GroupConfig />}/>
                  <Route path="group-report" element={<GroupReport/>} />

                  {/* <Route path="dashboard-gauge" element={<DashboardPage/>} />
                  <Route path="dashboard-trends" element={<SMMILSECStatistics/>} /> */}

                  <Route path="converters-meters" element={<DashConverters />} />
                <Route path="configuration-live" element={<DashLive />} />
                <Route path="configuration-energy" element={<DashEnergy />} />
                <Route path="configuration-groups" element={<GroupConfiguration />} />
                <Route path="configuration-roles" element={<UserRoles />} />
                <Route path="configuration-user-registration" element={<UserRegister />} />
                <Route path="configuration-screens" element={<ScreenConfiguration />} />
                </Route>

                
                <Route path={AR_NO_MATCH} element={<Navigate to={LOGIN} />} />
                <Route path={UNAUTHORIZED_PATH} element={<Navigate to={LOGIN} />} />

          </Routes>
        </HashRouter>
      </App>
            <CustomThemeDrawer
              title="Close"
              showDrawer={showThemeDrawer}
              open={openTheme}
              onClose={onThemeClose}
      
            >
              <div className="flex flex-col space-y-2">
              <div className=" mb-3">
                <div className={` text-lg  w-fit mb-1  ${ isdarkMode ? " text-white border-gray-400" : "text-black border-white"
              }`}>
                Select Primary Color
              </div>
              <Radio.Group buttonStyle="solid" onChange={handleChange} value={selectedTheme}>
                <Space className="flex flex-wrap w-full text-white pl-0 pb-4" > 
                <Radio.Button value="green" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}>Green</Radio.Button>
                  <Radio.Button value="blue" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}>Blue</Radio.Button>
                 
                  <Radio.Button value="red" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}>Red</Radio.Button>
                  <Radio.Button  value="purple" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}>Purple</Radio.Button>
                </Space>

                <div className={` text-lg  w-fit mb-1  ${ isdarkMode ? " text-white border-gray-400" : "text-black border-white"
              }`}>
                Select Custom Color
              </div>
                <ColorPicker defaultValue="#1677ff" size="large"
                 onChange={handleColorChange}
                 showText
                  />

                <div className="text-xs text-gray-500 mt-2">*Click on the color to select</div>
              </Radio.Group>
              </div>
              <div className=" mb-3">
              <div className={` text-lg w-fit mb-1  ${ isdarkMode ? " text-white border-gray-400" : "text-black border-white"
              }`}>
                Select Theme 
              </div>
              <Radio.Group size="large" buttonStyle="solid" onChange={switchDarkMode} value={selectedTheme}>
                <Space className="flex flex-wrap w-full text-2xl text-white pl-0 pb-4" > 
                  <Radio.Button   value="light" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}><SunOutlined className="mx-5"/></Radio.Button>
                  <Radio.Button  value="dark" className={`  !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}><MoonOutlined className=" mx-5"/></Radio.Button>
                </Space>
              </Radio.Group>
              </div>
               
              </div>
              {/* <div className="flex justify-center mt-4">
                            <Button
                              type= {isdarkMode? "":'primary'}
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              Search
                            </Button>
              </div> */}
            </CustomThemeDrawer>
    </ConfigProvider>
  
  );
}
